/*
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import { writable, get } from 'svelte/store';

const initialState = {
    component: null,
    props: {},
    options: {},
    isOpen: false
};

function createModalStore() {
    const store = writable(initialState);
    const { subscribe, set } = store;

    let animationTimeoutId;

    return {
        subscribe,
        open: (component, props = {}, options = {}) => {
            if (animationTimeoutId) {
                clearTimeout(animationTimeoutId);
                animationTimeoutId = null;
            }
            set({ component, props, options, isOpen: true });
        },
        close: () => {
            const aimationTimeout = get(store).options?.animationTimeout;
            if (aimationTimeout) {
                if (animationTimeoutId) {
                    clearTimeout(animationTimeoutId);
                }
                animationTimeoutId = setTimeout(() => {
                    set(initialState);
                    animationTimeoutId = null;
                }, aimationTimeout);
            } else {
                set(initialState);
            }
        }
    };
}

export const modalStore = createModalStore();
